export default function ({ store, redirect, route }) {
    if (!store.getters.fullserve && !store.getters.canAgent) {
        return redirect('/survey')
    }
}
